import { Component, OnInit } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {environment as env} from '../../../environments/environment';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  errMsg : string;
  errMsg_ar : string;
  isLoading:boolean;
  showLang:string;

  constructor(private http:HttpClient,private route:ActivatedRoute,
    private langObj:LanguageService,private router:Router) {
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
     }

  ngOnInit(): void { 
    this.showLang = localStorage.getItem("showLang");
     if(this.showLang == null && this.showLang == undefined){
      this.showLang = 'en';
     }
  }

  getEmail(phone){ 
    this.isLoading = true;
    //check if email exit with sajway and send otp
    if(phone !='' && phone !=undefined){
      this.http.post(env.apiurl+'forgetOtpMobile', {
        email:phone
      }).subscribe(rawData=>{
        this.isLoading =false;
        if(rawData['otp'] != undefined && rawData['otp'] != ''){
          localStorage.setItem('p_token', rawData['token']);
          localStorage.setItem('p_uid', rawData['userid']);
          localStorage.setItem('p_email', phone);
          this.router.navigate(['/register-verify', { isForgotpas: 1 }]);
        }else{
          this.errMsg = rawData['message'];
          this.errMsg_ar = rawData['message_ar'];
        }

      });
    }else{
      this.errMsg = "Please enter a valid email / mobile";
      this.errMsg_ar = "يرجى إدخال البريد الإلكتروني الصحيح";
      
    }
    
  }

}
